<div
  class="tab-pane fade flex-even active show"
  id="sales"
  role="tabpanel"
  aria-labelledby="sales-tab"
  >
  @if (this.contract$ | async; as contract) {
    <div
      class="d-flex flex-column h-100"
      >
      <div class="form-group-title my-1" translate>
        CONTRACT_FIELDSET_SHARED_COMMISSION
      </div>
      <div class="row mt-2">
        <div class="col-12 col-md">
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
              >CONTRACT_LBL_SHAREDSALESPERSON</label
              >
              <div class="col">
                <input
                  class="form-control-plaintext form-control-sm"
                  type="text"
                  readonly
                  value="{{ contract.sharedSalesPersonContactName }}"
                  />
                </div>
              </div>
              @if (contract.sharedSalesPersonId != null) {
                <div
                  class="form-group row"
                  >
                  <label class="col-4 col-form-label-sm" translate
                    >CONTRACT_LBL_SHAREDCOMMISSIONRATE</label
                    >
                    <div class="col">
                      <input
                        class="form-control-plaintext form-control-sm"
                        type="text"
                        readonly
                        value="{{ contract.sharedCommissionRate }} %"
                        />
                      </div>
                    </div>
                  }
                </div>
                <div class="col"></div>
              </div>
            </div>
          }
        </div>
